import Rocknut from './Rocknut.vue';
import Interview from './Interview.vue';
import Genrehis from './Genrehis.vue';
import Version from './Version.vue';
import Versionitem from './VersionItem.vue';
import Musicall from './Musicall.vue';
import ChronicleYear from './ChronicleYear.vue';

import { defineComponent, PropType } from 'vue';

import { ArticleModel, ChronicleYearModel, GenrehisModel, InterviewModel, MusicallModel, RankVersion, RocknutModel, VersionAlbumModel } from '@/typings';

export default defineComponent({
    name: 'ArticleListItem',
    props: {
        article: {
            type: Object as PropType<ArticleModel>,
            required: true
        },
        full: {
            type: Number,
            default: 0
        },
        showAlbum: {
            type: Boolean,
            default: false
        },
        position: {
            type: String,
            default: 'index'
        }
    },
    render () {
        // TODO 类型深坑
        const { article } = this.$props;
        const type = this.$props.article.article_type.index;

        if (type === 1) {
            return <Rocknut {...this.$props} article={article as RocknutModel} />;
        } else if (type === 2) {
            return <Interview {...this.$props} article={article as InterviewModel}/>;
        } else if (type === 3) {
            return <Genrehis {...this.$props} article={article as GenrehisModel}/>;
        } else if (type === 4) {
            return <Musicall {...this.$props} article={article as MusicallModel}/>;
        } else if (type === 11) {
            return <Version {...this.$props} article={article as RankVersion}/>;
        } else if (type === 12) {
            return <Versionitem {...this.$props} article={article as VersionAlbumModel}/>;
        } else if (type === 22) {
            return <ChronicleYear {...this.$props} article={article as ChronicleYearModel}/>;
        }
        return null;
    }
});
